import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setDairyHerdDetails, setDairyHerdDetailsAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_HERD_DETAILS } from "consts";

import { FootprintingDairyHerdDetails } from "models";

export const useMutateFootprintingDairyHerdDetails = (
  farmId: string,
  year: number,
  payload: Partial<Omit<FootprintingDairyHerdDetails, "id" | "primaryDataId">>,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_DAIRY_HERD_DETAILS, primaryDataId, isAdmin],
    mutationFn: () => (isAdmin ? setDairyHerdDetailsAdmin(payload, primaryDataId ?? "") : setDairyHerdDetails(payload, primaryDataId ?? "")),
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_DAIRY_HERD_DETAILS, primaryDataId, isAdmin],
        [FOOTPRINTING_DAIRY_HERD_DETAILS, farmId, year, isAdmin],
        ...footprintingDairyPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
      ]);
    },
  });
};
